export interface VehicleEcuDto {
  engineLoad?: number;
  engineCoolantTemperature?: number;
  intakeManifoldPressure?: number;
  speed?: number;
  intakeAirTemperature?: number;
  acceleratorPedalPosition?: number;
  engineOilTemperature?: number;
  engineRpm?: number;
  mafSensor?: number;
  vinNumber?: string;
}
